import React from 'react';
import './AsOfModal.scss';
import TRP from '../TRP/TRP';
import RASText from '../RASText/RASText';

const AsOfModal = ({type}) => {
  return (
  <div className="as-of-modal">
    <h2>Important Information Regarding the Updating of Account Balances</h2>
    <div id="body-text">
      {type === 'All' && (
        <p>
          <TRP/> mutual fund share prices and portfolio
          unit prices are calculated as of market close each business day and are
          generally updated on our website each business day between 6:30 p.m. and
          8 p.m. ET, at which time current account balances should reflect that
          updated price information.
        </p>
      )}
      {(type === 'All' || type === 'MANAGED_ACCOUNT') && (
      <p>
        T. Rowe Price ActivePlus Portfolios® account balances are generally
        updated overnight between 3:30 a.m. and 5:30 a.m. ET, at which time
        account balances should reflect information as of the most recent
        business day's market close.
      </p>
      )}
      {(type === 'All' || type.toLowerCase() === 'brokerage') && (
        <p>
          Prices and balances for positions held in T. Rowe Price brokerage accounts are generally
          updated overnight between 1 a.m. and 3 a.m. ET, at which time current prices and account
          balances should reflect information as of the most recent business day's market close which
          would not include changes in prices due to any after-market activity.
        </p>
      )}
      {(type === 'All' || type === 'AdviceManaged' || type === 'ADVICE_MANAGED') && (
        <p>
          Prices and balances for positions held in
          <TRP /> <RASText tradeMark /> accounts are generally updated
          overnight between 1 a.m. and 3 a.m. ET, at which time current prices
          and account balances should reflect information as of the most recent
          business day's market close.
        </p>
        )}
      {type === 'All' && (
        <p>
          <TRP/> mutual fund transactions{' '}for your
          account(s) during the current business day will be processed overnight
          and should be available to view online and reflected in your account
          balance the following morning. Intraday trading activity and pending
          account activity in your brokerage account will not be reflected in the
          account balance until the following morning.
        </p>
      )}
      {type === 'All' && (
        <p>
          Balances and holdings displayed for external investment accounts reflect information
          available on your account sites when last refreshed.
        </p>
      )}
    </div>
  </div>
  );
};

export default AsOfModal;
